import DestinationPage from '@/components/DestinationPage';

const LesLandes = () => {
  return (
    <DestinationPage
      title="Location de vélos dans les Landes"
      subtitle="Explorez les Landes à vélo : forêts de pins, lacs et côte atlantique"
      description="Les Landes offrent un terrain de jeu exceptionnel pour les cyclistes. Avec plus de 500 km de pistes cyclables, découvrez la plus grande forêt de pins d'Europe, les lacs paisibles, les villages landais et la côte atlantique sauvage. Une destination nature par excellence pour des vacances à vélo."
      highlights={[
        "Plus de 500 km de pistes cyclables",
        "Forêt de pins la plus grande d'Europe",
        "Lacs de Biscarrosse, Cazaux et Parentis",
        "Côte atlantique et spots de surf",
        "Villages landais authentiques",
        "Itinéraires nature et patrimoine"
      ]}
    />
  );
};

export default LesLandes;